import { render, staticRenderFns } from "./ProfileVideosForms.vue?vue&type=template&id=aae17ac0&"
import script from "./ProfileVideosForms.vue?vue&type=script&lang=js&"
export * from "./ProfileVideosForms.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVideosForms.vue?vue&type=style&index=0&id=aae17ac0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports